import script from "./ProjectDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectDetailView.vue?vue&type=style&index=0&id=65c2ba24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c2ba24"]])

export default __exports__